/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React, { Component } from 'react';
import {TextInput} from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import stateList from "../../../../config/us_ca_state_list";
import validator from "validator";
import PropTypes from "prop-types";
import {PERMISSIONS} from "../../../constants/constants";


export default class DeskCopy extends Component {
    static get propTypes() {
        return {
            enableSubmit: PropTypes.func.isRequired,
            updateDeskCopy: PropTypes.func.isRequired,
            updateBookBuildDetails: PropTypes.func.isRequired,
            deskCopies:PropTypes.object.isRequired,
            geoCode: PropTypes.string.isRequired,
            bookBuild: PropTypes.object.isRequired,
            permissions: PropTypes.array.isRequired,
        };
    }

    state ={
        adopterFirstNameInputState: 'default',
        adopterFirstNameErrorMsg: null,
        adopterLastNameInputState: 'default',
        adopterLastNameErrorMsg: null,
        deskCopyCountInputState:'default',
        deskCopyCountErrorMsg: null
    };

    handleDeskCopyTextInput = (field,value) => {
        const MAX_COURSE_LENGTH = 40;
        const inputLength = value.length;
        if(inputLength <= MAX_COURSE_LENGTH) {
            this.props.enableSubmit(true);
            this.props.updateDeskCopy(field,value);
        }
    };

    handleCopiesCountTextInput = (field,value) => {
        const MAX_COURSE_LENGTH = 40;
        const inputLength = value.length;
        if(inputLength <= MAX_COURSE_LENGTH) {
            this.props.enableSubmit(this.validateDeskCopyCount(field,value));
            this.props.updateDeskCopy(field,value);
        }
    };


    handleSelectOnChange = (event) => {
        this.props.enableSubmit(true);
        this.props.updateDeskCopy('state',event.target.value);
    };

    handleInsChangeInput = (field,value) => {
        const MAX_COURSE_LENGTH = 40;
        const inputLength = value.length;
        if(inputLength <= MAX_COURSE_LENGTH) {
            this.props.enableSubmit(this.validateAdopter(field,value));
            this.props.updateBookBuildDetails(field,value);
        }
    };

    validateDeskCopyCount= (field,value) =>{
        const regex = new RegExp(`^(?!(0))^[1-9][0-9]?$`);
        const deskCountCopy = regex.test(value);
        if(field === "copiesCount"){ 
            console.log(deskCountCopy); 
            this.setState({
                deskCopyCountInputState: deskCountCopy ? 'default' : 'error',
                deskCopyCountErrorMsg: deskCountCopy  ? null :'Enter values only between 1 to 99'
            });    
        }
        return deskCountCopy;
    };

    validateAdopter = (field,value) =>{
        const isEmpty = validator.isEmpty(value);
        if(field === "adopterFirstName"){
            this.setState({
                adopterFirstNameInputState: isEmpty ? 'error' : 'default',
                adopterFirstNameErrorMsg: isEmpty ? `Adopter First Name is required` : null
            });
        }else if(field === "adopterLastName"){
            this.setState({
                adopterLastNameInputState: isEmpty ? 'error' : 'default',
                adopterLastNameErrorMsg: isEmpty ? `Adopter Last Name is required` : null
            });
        }
        return !isEmpty;
    };

    render(){
        return (
            <div className="desk-copy pe-row">
                <div className="pe-col-12">
                    <div className="pe-row">
                        <div className="pe-col-4">
                            <label className="pe-label--bold">Full Desk Copy Shipping Address</label>
                        </div>
                        <div className="pe-col-4">
                            <TextInput id="deskcopies"
                                labelText="No. of Desk Copies Requested" fancy={false}
                                placeholder={"copiesCount"}
                                type= {"number"}
                                inputState= {this.state.deskCopyCountInputState}
                                errorMessage={this.state.deskCopyCountErrorMsg}
                                changeHandler={(e)=>{this.handleCopiesCountTextInput('copiesCount', e.target.value);}}
                                value={this.props.deskCopies.copiesCount}
                                inputState={this.props.permissions.includes(PERMISSIONS.view_only_desk_copies)? 'disabled' : ''}
                            />
                        </div>
                    </div>
                    <div className="main-row">
                        <div className="pe-row">
                            <div className="pe-col-4">
                                <TextInput id="Institute"
                                    labelText="Institute"
                                    fancy={false}
                                    placeholder={"School Name"}
                                    changeHandler={(e)=>{this.handleDeskCopyTextInput('school', e.target.value);}}
                                    value={this.props.deskCopies.addressLine1}
                                    inputState={this.props.permissions.includes(PERMISSIONS.view_only_institute)? 'disabled' : ''}
                                />
                            </div>
                            <div className="pe-col-4 hidden">
                                <TextInput id="Institute-2"
                                    fancy={false}
                                    labelText={'&nbsp;'}
                                    placeholder={"Department"}
                                    changeHandler={(e)=>{this.handleDeskCopyTextInput('department', e.target.value);}}
                                    value={this.props.deskCopies.addressLine2}
                                    inputState={this.props.permissions.includes(PERMISSIONS.view_only_department)? 'disabled' : ''}
                                />
                            </div>
                        </div>
                        <div className="pe-row margin-top">
                            <div className="pe-col-4">
                                <TextInput id="Instructor"
                                    labelText="Instructor" fancy={false}
                                    placeholder={"First Name"}
                                    inputState= {this.state.adopterFirstNameInputState}
                                    errorMessage={this.state.adopterFirstNameErrorMsg}
                                    changeHandler={(e)=>{this.handleInsChangeInput('adopterFirstName', e.target.value);}}
                                    value={this.props.bookBuild.adopterFirstName}
                                    inputState={this.props.permissions.includes(PERMISSIONS.view_only_instructor)? 'disabled' : ''}
                                />
                            </div>
                            <div className="pe-col-4 hidden">
                                <TextInput id="Instructor-2"
                                    fancy={false}
                                    labelText={'&nbsp;'}
                                    placeholder={"Last Name"}
                                    inputState= {this.state.adopterLastNameInputState}
                                    errorMessage={this.state.adopterLastNameErrorMsg}
                                    changeHandler={(e)=>{this.handleInsChangeInput('adopterLastName', e.target.value);}}
                                    value={this.props.bookBuild.adopterLastName}
                                    inputState={this.props.permissions.includes(PERMISSIONS.view_only_instructor2)? 'disabled' : ''}
                                />
                            </div>
                        </div>
                        <div className="pe-row margin-top">
                            <div className="pe-col-4">
                                <TextInput id="Address1"
                                    labelText="Address Line 1"
                                    fancy={false}
                                    changeHandler={(e)=>{this.handleDeskCopyTextInput('addressLine1', e.target.value);}}
                                    value={this.props.deskCopies.addressLine1}
                                    inputState={this.props.permissions.includes(PERMISSIONS.view_only_address1)? 'disabled' : ''}
                                />
                            </div>
                            <div className="pe-col-4">
                                <TextInput id="Address12"
                                    fancy={false}
                                    labelText={'Address Line 2'}
                                    changeHandler={(e)=>{this.handleDeskCopyTextInput('addressLine2', e.target.value);}}
                                    value={this.props.deskCopies.addressLine2}
                                    inputState={this.props.permissions.includes(PERMISSIONS.view_only_address2)? 'disabled' : ''}
                                />
                            </div>
                        </div>
                        <div className="pe-row margin-top">
                            <div className="pe-col-4">
                                <TextInput id="Address3" labelText="Address Line 3" fancy={false}
                                    changeHandler={(e)=>{this.handleDeskCopyTextInput('addressLine3', e.target.value);}}
                                    value={this.props.deskCopies.addressLine3}
                                    inputState={this.props.permissions.includes(PERMISSIONS.view_only_address3)? 'disabled' : ''}
                                />
                            </div>
                        </div>
                        <div className="pe-row margin-top">
                            <div className="pe-col-4">
                                <TextInput id="city" labelText="City" fancy={false}
                                    changeHandler={(e)=>{this.handleDeskCopyTextInput('city', e.target.value);}}
                                    value={this.props.deskCopies.city}
                                    inputState={this.props.permissions.includes(PERMISSIONS.view_only_city)? 'disabled' : ''}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="pe-row margin-top">
                        <div className="pe-col-4">
                            <label className="pe-title--secondary" htmlFor="state">State</label>
                            <div className="pe-select-container">
                                <select className="pe-selectInput--basic" id="state"
                                    onChange={this.handleSelectOnChange} disabled={this.props.permissions.includes(PERMISSIONS.view_only_state)}>
                                    {stateList[this.props.geoCode].map((entity, i) => {
                                        if (entity.abbreviation === this.props.deskCopies.state) {
                                            return <option selected key={i}
                                                value={entity.abbreviation}> {entity.name} </option>;
                                        } else {
                                            return <option key={i}
                                                value={entity.abbreviation}> {entity.name} </option>;
                                        }
                                    })
                                    }
                                    
                                </select>
                                <svg aria-hidden="true"
                                    focusable="false"
                                    className="pe-icon--dropdown-open-18">
                                    <use xlinkHref="#dropdown-open-sm-18"></use>
                                </svg>
                            </div>
                        </div>

                    </div>
                    <div className="pe-row margin-top">
                        <div className="pe-col-4">
                            <TextInput id="zip-code" labelText="Zip Code" fancy={false}
                                changeHandler={(e)=>{this.handleDeskCopyTextInput('zipCode', e.target.value);}}
                                value={this.props.deskCopies.zipCode}
                                inputState={this.props.permissions.includes(PERMISSIONS.view_only_zip_code)? 'disabled' : ''}
                            />
                        </div>
                    </div>
                    <div className="pe-row margin-top">
                        <div className="pe-col-4">
                            <TextInput id="country" labelText="Country" fancy={false}
                                inputState="disabled"
                                disabled={true}
                                value={this.props.geoCode && this.props.geoCode === 'US' ? 'United States' : 'Canada' }
                                inputState={this.props.permissions.includes(PERMISSIONS.view_only_country)? 'disabled' : ''}
                            />
                        </div>
                    </div>
                </div>
                <div className="pe-col-6">

                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/OrderDetailsComponents/DeskCopy.js